export const _gamesTableFr = {
    titleMyGames: 'Mes parties',
    titleGames: 'Parties du module',
    gameNames: 'Nom',
    gameDescription: 'Description',
    gamePlayersNb: 'Nombre de joueurs',
    noGame: 'Vous n\'avez actuellement aucune partie sur le module RolePlay',
    newGame: 'Créer une nouvelle partie',
    searchGame: 'Rechercher une autre partie',
    join: 'Rejoindre',
    noGameToJoin: 'Aucune partie n\'est actuellement disponible',
    cancelJoin: 'Annuler la demande',
    vehicleType: 'Type de véhicule',
    vehicleName: 'Nom du véhicule',
    vehicleStatus: 'Statut du véhicule',
    functions: 'Fonctions',
};

export const _gamesTableEn = {
    titleMyGames: 'My games',
    titleGames: 'Games of module',
    gameNames: 'Name',
    gameDescription: 'Description',
    gamePlayersNb: 'Numbers of players',
    noGame: 'You currently have no game on the RolePlay module',
    newGame: 'Create a new game',
    searchGame: 'Find another game',
    join: 'Join',
    noGameToJoin: 'No game is currently available',
    cancelJoin: 'Cancel Request',
    vehicleType: 'Vehicle type',
    vehicleName: 'Vehicle name',
    vehicleStatus: 'Vehicle status',
    functions: 'Functions',
};

export const _gamesTableDe = {
    titleMyGames: 'Meine Spiele',
    titleGames: 'Spiele des Moduls',
    gameNames: 'Name',
    gameDescription: 'Beschreibung',
    gamePlayersNb: 'Anzahl der Spieler',
    noGame: 'Sie haben derzeit kein Spiel auf dem RolePlay-Modul',
    newGame: 'Neues Spiel erstellen',
    searchGame: 'Suchen Sie ein anderes Spiel',
    join: 'Beitreten',
    noGameToJoin: 'Kein Spiel ist derzeit verfügbar',
    cancelJoin: 'Anfrage abbrechen',
    vehicleType: 'Fahrzeugtyp',
    vehicleName: 'Fahrzeugname',
    vehicleStatus: 'Fahrzeugstatus',
    functions: 'Funktionen',
};
